import React from 'react';
import { HasAccess } from "@permify/react-role";

const DialogflowChat = () => {
  return (
    <HasAccess roles={['doctor']}>
      <a
        href="https://notebooklm.google.com/notebook/25a3e0a5-c675-4a6f-91ec-3950fc7abe4e"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '60px',
          height: '60px',
          backgroundColor: '#000000',
          borderRadius: '50%',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          transition: 'transform 0.2s ease-in-out',
          cursor: 'pointer',
        }}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
        title="Abrir en NotebookLM"
      >
        <img
          src="https://unpkg.com/@lobehub/icons-static-svg@1.88.0/icons/notebooklm.svg"
          alt="NotebookLM"
          style={{ width: '36px', height: '36px', filter: 'brightness(0) invert(1)' }}
        />
      </a>
    </HasAccess>
  );
};

export default DialogflowChat;